module.exports = __webpack_public_path__ + "static/media/Upload dealshub products SKU.b6d4b86b.xlsx";